module.exports = __webpack_public_path__ + "img/logo-theme-green-dark.0785a622.svg";